import React, { useState } from 'react';
import { FlexAround } from '../../../../../../styles/stylesStyled';
import { useSelector } from 'react-redux';
import { ZeroLevelInfo } from './ZeroLevelInfo';
import {
  GoLeftDownArrowButton,
  GoRightDownArrowButton,
  GoUpArrowButton
} from '../../../common';
import { LevelOne } from '../../common/LevelOne/LevelOne';

export const LevelZero = () => {
  const { rootTeamMemberTrading } = useSelector(
    (store) => store.myTeamBackoffice
  );
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <FlexAround>
        <div>
          <GoUpArrowButton />
          <GoLeftDownArrowButton />
        </div>
        <div onClick={() => setIsOpen(!isOpen)} style={{ display: 'flex' }}>
          <LevelOne teamMember={rootTeamMemberTrading} />
        </div>
        <div>
          <GoUpArrowButton />
          <GoRightDownArrowButton />
        </div>
      </FlexAround>

      <ZeroLevelInfo isOpen={isOpen} />
    </>
  );
};
